import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { UserState } from "./userStore.types";

const initialUserState = {
  userId: null,
  userJwt: null,
  userType: null,
  modules: null,
  jwtUserId: null,
  userEmail: null,
  userName: null,
  userRoles: null,
  entityName: null,
  isEntityLogin: null,
  isMainAppLogin: null,
  tenantId: null,
};

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      ...initialUserState,
      setUserId: (value) => set({ userId: value }),
      setUserJwt: (value) => set({ userJwt: value }),
      setUserType: (value: "super_admin" | string | null) => set({ userType: value }),
      setModules: (value: string[] | null) => set({ modules: value }),
      setJwtUserId: (value) => set({ jwtUserId: value }),
      setUserEmail: (value) => set({ userEmail: value }),
      setUserName: (value) => set({ userName: value }),
      setUserRoles: (value) => set({ userRoles: value }),
      setEntityName: (value) => set({ entityName: value }),
      setIsEntityLogin: (value) => set({ isEntityLogin: value }),
      setIsMainAppLogin: (value) => set({ isMainAppLogin: value }),
      setTenantId: (value) => set({ tenantId: value }),
      resetUserStore: () => {
        set(initialUserState);
      },
    }),
    {
      name: "user-store",
    },
  ),
);
